import React from 'react';

import theNewsLogo from '../../../../Assets/Linkages/SpaceSummerSchool/Media/the-news.ico';
import expressTribuneLogo from '../../../../Assets/Linkages/SpaceSummerSchool/Media/express-tribune.ico';
import proPakistaniLogo from '../../../../Assets/Linkages/SpaceSummerSchool/Media/propakistani.ico';
import islamabadSceneLogo from '../../../../Assets/Linkages/SpaceSummerSchool/Media/islamabad-scene.ico';
import eduNewsLogo from '../../../../Assets/Linkages/SpaceSummerSchool/Media/edunews.ico';
import dailyTimesLogo from '../../../../Assets/Linkages/SpaceSummerSchool/Media/daily-times.ico';

const coverage = [
  {
    year: '2026',
    outlet: 'Associated Press of Pakistan',
    title: '10th Space Summer School opens at IST to inspire future space scientists',
    url: 'https://www.app.com.pk/national/10th-space-summer-school-opens-at-ist-to-inspire-future-space-scientists/',
    logo: null,
  },
  {
    year: '2024',
    outlet: 'The News International',
    title: 'Space Summer School starts tomorrow at IST',
    url: 'https://www.thenews.com.pk/print/1216379-space-summer-school-starts-tomorrow-at-ist',
    logo: theNewsLogo,
  },
  {
    year: '2024',
    outlet: 'Daily Times',
    title: 'Eighth Space Summer School to be held at IST from Aug 05–09',
    url: 'https://dailytimes.com.pk/1207527/eighth-space-summer-school-to-be-held-at-ist-from-aug-05-09/',
    logo: dailyTimesLogo,
  },
  {
    year: '2022',
    outlet: 'The Express Tribune',
    title: 'Space Summer School receives huge response',
    url: 'https://tribune.com.pk/story/2368023/space-summer-school-receives-huge-response',
    logo: expressTribuneLogo,
  },
  {
    year: '2022',
    outlet: 'The News International',
    title: 'Space Summer School to be held from July 25',
    url: 'https://www.thenews.com.pk/print/971011-space-summer-school-to-be-held-from-july-25',
    logo: theNewsLogo,
  },
  {
    year: '2022',
    outlet: 'ProPakistani',
    title: 'IST Islamabad to organize Space Summer School next month',
    url: 'https://propakistani.pk/2022/06/28/space-summer-school-to-be-held-next-month-in-islamabad/',
    logo: proPakistaniLogo,
  },
  {
    year: '2020',
    outlet: 'The News International',
    title: 'Space Summer School launched',
    url: 'https://www.thenews.com.pk/print/702233-space-summer-school-launched',
    logo: theNewsLogo,
  },
  {
    year: '2019',
    outlet: 'Islamabad Scene',
    title: 'Space Summer School 2019 begins at IST Islamabad',
    url: 'https://www.islamabadscene.com/space-summer-school-2019-begins-at-ist-islamabad/',
    logo: islamabadSceneLogo,
  },
  {
    year: '2018',
    outlet: 'EduNews',
    title: 'Summer School at IST',
    url: 'https://www.edunews.pk/news/7/summer-school-at-ist',
    logo: eduNewsLogo,
  },
  {
    year: '2017',
    outlet: 'The Express Tribune',
    title: 'First Space Summer School begins at IST',
    url: 'https://tribune.com.pk/story/1460306/first-space-summer-school-begins-ist',
    logo: expressTribuneLogo,
  },
  {
    year: '2017',
    outlet: 'Islamabad Scene',
    title: "Pakistan's first Space Summer School kicks off in Islamabad",
    url: 'https://www.islamabadscene.com/pakistans-first-space-summer-school-2017-kicks-off-in-islamabad/',
    logo: islamabadSceneLogo,
  },
];

const SummerSchoolMediaCoverage = () => (
  <section className="summer-school-media" aria-labelledby="summer-school-media-title">
    <div className="summer-school-media-inner">
      <header className="summer-school-media-header">
        <p className="summer-school-eyebrow">IN THE NEWS</p>
        <h2 id="summer-school-media-title">Media Coverage</h2>
        <div className="summer-school-title-line" aria-hidden="true" />
      </header>

      <div className="summer-school-media-grid">
        {coverage.map((article) => (
          <a
            className="summer-school-media-card"
            href={article.url}
            target="_blank"
            rel="noopener noreferrer"
            key={article.url}
            aria-label={`${article.title} — ${article.outlet}, ${article.year}`}
          >
            <div className="summer-school-media-logo-wrap">
              {article.logo ? (
                <img src={article.logo} alt={`${article.outlet} logo`} loading="lazy" />
              ) : (
                <span className="summer-school-media-logo-fallback" aria-hidden="true">APP</span>
              )}
            </div>
            <div className="summer-school-media-copy">
              <div className="summer-school-media-meta">
                <span>{article.outlet}</span>
                <time>{article.year}</time>
              </div>
              <h3>{article.title}</h3>
              <span className="summer-school-media-link">Read article <span aria-hidden="true">→</span></span>
            </div>
          </a>
        ))}
      </div>
    </div>
  </section>
);

export default SummerSchoolMediaCoverage;
